import React from 'react';

// Utils
import { getEnvironmentApiUrl } from '../../../services/General';
import { getUser } from '../../../services/Auth';
import { getFullName } from '../../../services/getPatientAtribute';

// Hooks
import useHttp from '../../../hooks/useHttp';
import { useTranslation } from 'react-i18next';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

// Models
import { Device } from '../../../interfaces/Device';
interface Props {
    device: Device
    widtdrawDeviceLocally: (deviceID: Device["id"]) => void
    closeModal: () => void
}

const DialogWithdrawDevice: React.FC<Props> = ({ device, widtdrawDeviceLocally, closeModal }) => {

    const { sendRequest } = useHttp();

    const { t } = useTranslation();

    const currentLoan = device.loans?.find(loan => loan.return_date === null)

    const onConfirm = () => {
        if (!device.loans || device.loans.length === 0) return;
        if (!currentLoan) return;
        sendRequest({
            url: getEnvironmentApiUrl() + 'device_loan',
            method: 'PUT',
            body: {
                data: {
                    return_date: new Date().toISOString(),
                    return_user_id: getUser()?.id,
                    deleted: true
                },
                filter: {
                    id: currentLoan.id
                }
            }
        }, () => {
            widtdrawDeviceLocally(device.id);
            closeModal();
        })
    }


    return (
        <div className='dialog' style={{ textAlign: 'center' }}>
            <h1 className='dialogSubTitle'>
                {t('the_device')}{' '}
                <strong>{device.device_type?.name} {device.model?.manufacturer?.name} {device.model?.name} </strong>
                {t('will_be_withdrawn_from_patient')}:
                <strong> {getFullName(currentLoan?.patient)}</strong>
            </h1>
            <CancelConfirmButtons
                onCancel={closeModal}
                onConfirm={onConfirm}
            />
        </div>
    );
};

export default DialogWithdrawDevice;